import SmartTipFeedback from './SmartTipFeedback';

export default SmartTipFeedback;
